import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { useLead } from '../contexts/LeadContext';
import { PhotoPlaceholder } from './PhotoPlaceholder';
import { Reveal } from './Reveal';
import { GoldBow } from './GoldBow';
import { scrollToLeadForm } from '../utils/scroll';
export function FinalCTA() {
  const {
    t
  } = useLanguage();
  const {
    openPicker
  } = useLead();
  return <section className="w-full bg-white" data-id="element-41" data-mp="m4f2mcjbqg11">
      <div className="mx-auto w-full max-w-7xl px-4 pb-16 pt-4 sm:px-6 md:pb-24" data-id="element-42" data-mp="m3dscaa4txkd">
        <Reveal className="mx-auto max-w-3xl text-center" data-id="element-43" data-mp="h4u05s4y3pjk">
          <GoldBow className="mx-auto h-7 w-10" data-id="element-44" data-mp="vurtemhqf5fm" />
          <h2 className="mt-6 font-display text-3xl font-extrabold uppercase leading-[1.02] tracking-[-0.02em] text-ink sm:text-5xl" data-id="element-45" data-mp="vu8dtcfk0t4r">
            {t('final.title')}
          </h2>

          <div className="mx-auto mt-8 flex w-full max-w-lg flex-col gap-3 sm:flex-row" data-id="element-46" data-mp="14whoc2atomi5">
            <button type="button" onClick={scrollToLeadForm} className="min-h-[52px] flex-1 bg-gold px-6 text-sm font-bold uppercase tracking-[0.12em] text-golddeep transition-transform hover:-translate-y-[1px]" data-id="element-47" data-mp="zx4pskal9qzq">
              {t('hero.ctaPrimary')}
            </button>
            <button type="button" onClick={() => openPicker('final-cta')} className="min-h-[52px] flex-1 border border-ink px-6 text-sm font-bold uppercase tracking-[0.12em] text-ink transition-colors hover:bg-ink hover:text-white" data-id="element-48" data-mp="2m19f3enm4c8g">
              {t('hero.ctaSecondary')}
            </button>
          </div>

          <p className="mt-8 font-display text-xs font-bold uppercase tracking-[0.26em] text-ink/70" data-id="element-49" data-mp="34ssivnpgnubj">
            {t('hero.tagline')}
          </p>
        </Reveal>

        {/* Photograph carries no overlay, scrim, or filter. */}
        <Reveal className="mt-12" delay={0.1} data-id="element-50" data-mp="3est1t8jf48f7">
          <div className="aspect-[16/9] w-full overflow-hidden sm:aspect-[21/9]" data-id="element-51" data-mp="3it3a4ruonax8">
            <PhotoPlaceholder label={t('final.photo')} tone="warm" data-id="element-52" data-mp="3ir0hs16255pc" />
          </div>
        </Reveal>
      </div>
    </section>;
}